import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '../shared/models/api-response';
import { ChapterInfo } from './chapters.models';
@Injectable({
  providedIn: 'root'
})
export class ChaptersService {

  constructor(private http: HttpClient) { }

  getAvailableChapters(licenseId: string) {
    return this.http.get<ApiResponse<ChapterInfo[]>>(`api/chapter/getchapters?licenseId=${licenseId}`);
  }
   
  UpdateChapters(licenseId: string, chapters: Array<ChapterInfo>) {
    var params = {
      licenseId: licenseId,
      chapters: chapters
    };
    
    return this.http.post<ApiResponse<boolean>>(`api/chapter/updatechapters`, params);
  }
}
